import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=04ae81c5&"
import script from "./UserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UserInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ae81c5')) {
      api.createRecord('04ae81c5', component.options)
    } else {
      api.reload('04ae81c5', component.options)
    }
    module.hot.accept("./UserInfoModal.vue?vue&type=template&id=04ae81c5&", function () {
      api.rerender('04ae81c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/UserInfoModal.vue"
export default component.exports